import { Component, Input, Output, EventEmitter } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { RouterModule } from "@angular/router";
import { VFIconComponent } from "../../../../vficon/vficon.component";
import { TableCell, TableRow } from "../../../../../models/common-table";
import { CommonTableGridHandlers } from "../common-table-grid.component";
import {
  getCellValueAsArray,
  getCellValueAsString,
  getCellValueAsStringOrDash,
  getTooltipValue,
  getIconNameValue,
  getIconNameByIndexValue,
  cellValueIncludes,
  getCellValueLength,
} from "../../../../../utils/common-table.utils";

@Component({
  selector: "app-cell-type-renderer",
  standalone: true,
  imports: [CommonModule, FormsModule, TooltipModule, RouterModule, VFIconComponent],
  templateUrl: "./cell-type-renderer.component.html",
  styleUrls: ["../../../common-table.component.scss"],
})
export class CellTypeRendererComponent {
  @Input() cell: TableCell<unknown> | undefined;
  @Input() rowIndex!: number;
  @Input() colIndex!: number;
  @Input() columnTitle!: string;
  @Input() handlers!: CommonTableGridHandlers;
  @Input() backgroundColors!: { warning: string; success: string; danger: string; white: string; default: string };
  @Input() emptyValues: string[] = [];
  @Input() row: TableRow | undefined;

  @Output() cellChange = new EventEmitter<{
    event: unknown;
    data: unknown;
    column: string;
    row: TableRow;
    options?: Record<string, unknown> | null;
    action?: string;
  }>();

  public onCellChange(
    event: unknown,
    data: unknown,
    column: string,
    rowData: TableRow,
    options?: Record<string, unknown> | null,
    action?: string,
  ): void {
    this.cellChange.emit({ event, data, column, row: rowData, options, action });
  }

  isArray: typeof Array.isArray = Array.isArray;

  // Expose utility functions for template use
  getCellValueAsArray = (value: unknown): unknown[] => getCellValueAsArray(value);
  getCellValueAsString = (value: unknown): string => getCellValueAsString(value);
  getCellValueAsStringOrDash = (value: unknown): string => getCellValueAsStringOrDash(value);
  getTooltipValue = (tooltip: string | string[] | undefined): string => getTooltipValue(tooltip);
  getIconNameValue = (icons: string | string[] | undefined): string => getIconNameValue(icons);
  getIconNameByIndexValue = (icons: string | string[] | undefined, index: number): string =>
    getIconNameByIndexValue(icons, index);
  cellValueIncludes = (cellValue: unknown, selected: unknown): boolean => cellValueIncludes(cellValue, selected);
  getCellValueLength = (value: unknown): number => getCellValueLength(value);

  public getCopyValue(): string {
    const value: unknown = this.cell?.href ?? this.cell?.rawValue ?? this.cell?.value;
    return getCellValueAsString(value);
  }
}
